import { render, staticRenderFns } from "./Maintenance.vue?vue&type=template&id=b2201b46&scoped=true"
import script from "./Maintenance.vue?vue&type=script&lang=js"
export * from "./Maintenance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2201b46",
  null
  
)

export default component.exports